module.exports = __webpack_public_path__ + "static/media/microfono-camara.248e0548.png";